import React, { useEffect } from "react";
import { Nav, Navbar, Container } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";

// store
import { RootState } from "../../redux/store";

// images
// import logoDark from "../../assets/images/logo-dark.png";
// import logoLight from "../../assets/images/logo-light.png";

//import logoDark from "../../assets/images/aiimslogo.png";
// import logoDark from "../../assets/images/logo.png";
import logoDark from "../../assets/images/bssa logo white.png";
//import logoLight from "../../assets/images/aiims_logo_sms.jpg";
// import logoLight from "../../assets/images/logo.jpg";
import logoLight from "../../assets/images/bssa logo white.png";
import logoBiharGov from "../../assets/images/bihar sarkar logo.png";
import logoBiharSport from "../../assets/images/Khel wibhaag-012.png";
import logoBiharAduc from "../../assets/images/BiharAducation.png";
import logoBEPC from "../../assets/images/BEPCLogo.png";
import logoSERT from "../../assets/images/scertlogo.png";

// aiims_patna_logo.png

const NavBar = () => {
  const { user, userLoggedIn } = useSelector((state: RootState) => ({
    user: state.Auth.user,
    loading: state.Auth.loading,
    error: state.Auth.error,
    userLoggedIn: state.Auth.userLoggedIn,
  }));

  // on scroll add navbar class
  useEffect(() => {
    // manage scroll
    const navbar = document.getElementById("nav-menu");
    window.addEventListener("scroll", (e) => {
      e.preventDefault();
      if (navbar) {
        if (
          document.body.scrollTop >= 50 ||
          document.documentElement.scrollTop >= 50
        ) {
          navbar.classList.add("nav-sticky", "shadow");
        } else {
          navbar.classList.remove("nav-sticky", "shadow");
        }
      }
    });
  }, []);

  return (
    <>
      <Navbar
        collapseOnSelect
        expand={"lg"}
        className="py-lg-2  sticky-top "
        id="nav-menu"
        style={{ background: " linear-gradient(to right, #ae362e, #0c2d5a )" }}
      >
        <Container className="hederSection ">
          <div className="auth-logo me-lg-5 d-flex justify-content-center align-items-center m-0">
            <div>
              <Link to="/" className="logo logo-dark">
                <span className="logo-lg">
                  <img src={logoDark} alt="" className="me-2" height="" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-lg">
                  <img src={logoLight} alt="" className="me-2" height="24" />
                </span>
              </Link>
            </div>
            <div className="mt-3 ">
              <h3 style={{ color: "white", marginLeft: "15px" }}>
                {/* बिहार
                <span style={{ color: "rgb(240, 86, 35)" }}>
                  {" "}
                  राज्य खेल
                </span>{" "}
                प्राधिकरण <br />
                <small style={{ color: "rgb(1, 105, 56)" }}>बिहार सरकार</small> */}
                बिहार राज्य विद्यालय खेल-सह-प्रतिभा खोज
              </h3>
            </div>
          </div>

          <div className="auth-logo me-lg-0  d-flex justify-content-center align-items-center mr-0 ">
            <div>
              <Link to="/" className="logo logo-dark">
                <span className="logo-lg">
                  <img src={logoBiharSport} alt="" className="me-2" height="" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-lg">
                  <img
                    src={logoBiharSport}
                    alt=""
                    className="me-2"
                    height="24"
                  />
                </span>
              </Link>
            </div>
            <div>
              <Link to="/" className="logo logo-dark">
                <span className="logo-lg">
                  <img src={logoSERT} alt="" className="me-2" height="" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-lg">
                  <img src={logoSERT} alt="" className="me-2" height="24" />
                </span>
              </Link>
            </div>
            <div>
              <Link to="/" className="logo logo-dark">
                <span className="logo-lg">
                  <img src={logoBEPC} alt="" className="me-2" height="" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-lg">
                  <img src={logoBEPC} alt="" className="me-2" height="24" />
                </span>
              </Link>
            </div>
            <div>
              <Link to="/" className="logo logo-dark">
                <span className="logo-lg">
                  <img src={logoBiharAduc} alt="" className="me-2" height="" />
                </span>
              </Link>

              <Link to="/" className="logo logo-light">
                <span className="logo-lg">
                  <img
                    src={logoBiharAduc}
                    alt=""
                    className="me-2"
                    height="24"
                  />
                </span>
              </Link>
            </div>
          </div>
        </Container>
      </Navbar>
      <div>
        <Navbar
          collapseOnSelect
          expand={"lg"}
          className="py-lg-2   "
          id="nav-menu"
          style={{ background: "#0c2d5a", color: "white" }}
        >
          <Container>
            <Navbar.Toggle
              className="shadow-none border-0 px-0 text-light"
              aria-controls="responsive-navbar-nav"
            >
              <i className="uil uil-bars" style={{ fontSize: "1.7rem" }}></i>
            </Navbar.Toggle>
            <Navbar.Collapse id="responsive-navbar-nav">
              {/* left menu */}
              <Nav as="ul" className="me-auto align-items-center"></Nav>

              {/* right menu */}
              <Nav
                as="ul"
                className="ms-auto align-items-lg-center fs-16 fw-bold"
              >
                <Nav.Item as="li" className="mx-lg-1">
                  <Nav.Link href="/home" className="text-light link-demos">
                    HOME
                  </Nav.Link>
                </Nav.Item>
                {/* <Nav.Item as="li" className="mx-lg-1">
                  <Nav.Link
                    href="/auth/login"
                    className="text-light link-demos"
                  >
                    ADMIN LOGIN
                  </Nav.Link>
                </Nav.Item> */}
                <Nav.Item as="li" className="mx-lg-1">
                  <Nav.Link
                    href="/auth/login"
                    className="text-light link-demos"
                  >
                    LOGIN
                  </Nav.Link>
                </Nav.Item>

                <Nav.Item as="li" className="mx-lg-1">
                  <Nav.Link href="/helpdesk" className="text-light link-demos">
                    HELPDESK
                  </Nav.Link>
                </Nav.Item>

                {/* <Nav.Item as="li" className="mx-lg-1">
                <Nav.Link href="#demos" className="text-dark link-demos">
                  Demos
                </Nav.Link>
              </Nav.Item> */}

                {/* <Nav.Item as="li" className="mx-lg-1">
                {userLoggedIn || user ? (
                  <Nav.Link
                    as={Link}
                    to="/auth/logout"
                    className="text-dark link-demos"
                  >
                    Logout
                  </Nav.Link>
                ) : (
                  <Nav.Link
                    as={Link}
                    to="/auth/login"
                    className="text-dark link-demos"
                  >
                    Login
                  </Nav.Link>
                )}
              </Nav.Item> */}
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </>
  );
};

export default NavBar;
